/**
 * Corpus figures quoted in marketing copy.
 *
 * These appear on Home, Pricing, the FAQ and About. Before this file they would
 * have been six hand-typed literals, which is the shape of every number that
 * quietly goes stale: one of them gets updated and the other five keep claiming
 * last quarter's corpus. One fact, one owner.
 *
 * MEASURED ON PRODUCTION, NOT ESTIMATED. Re-measure before changing any of
 * them, and move MEASURED_ON with them:
 *
 *   SELECT count(*) FROM funders;                              -> GRANTMAKERS
 *   SELECT count(*) FROM funder_grants;                        -> GRANTS_PAID
 *   SELECT count(*) FROM funders WHERE filing_form = '990';    -> PUBLIC_CHARITY_GRANTMAKERS
 *   SELECT count(*) FROM assistance_listings;                  -> FEDERAL_PROGRAMS
 *   SELECT min(irs_990_year), max(irs_990_year) FROM funders;  -> FILING_YEARS
 *
 * ⚠️ Two figures deliberately absent, because they cannot be stated without a
 * denominator and marketing copy has no room for one:
 *   - 110,132 of 171,801 funders carry an embedding (64%, 2026-10-16). So the
 *     site may claim the MECHANISM ("matched on your mission, not a keyword")
 *     and must not claim it runs across every grantmaker.
 *   - `grants` holds 3,644 rows but only 724 are posted and 543 forecasted
 *     (2026-10-16). Any live federal count is the posted figure, never the
 *     table size. FEDERAL_PROGRAMS below is the assistance-listing catalogue,
 *     which is a different and stable thing.
 *
 * ⚠️ Refresh these WITH the /funding snapshot (`frontend/src/data/
 * fundingPages.json`, procedure in docs/seo.md), never apart from it.
 * `test_corpus_figures.py` fails when GRANTMAKERS or MEASURED_ON disagree with
 * that snapshot, so the snapshot's 120-day staleness alarm covers this file
 * too. Until 2026-10-16 nothing did, and the homepage quoted the August corpus
 * for two months after an import doubled the grant count.
 */

/** Every US grantmaker we hold an IRS filing for. */
export const GRANTMAKERS = 171801

/** Grants those grantmakers actually paid, across all held filings. */
export const GRANTS_PAID = 12423178

/** Of GRANTMAKERS, the ones filing a 990 Schedule I rather than a 990-PF. */
export const PUBLIC_CHARITY_GRANTMAKERS = 28349

/** Federal assistance listings (the CFDA programme catalogue). */
export const FEDERAL_PROGRAMS = 2884

/** Range of IRS filing years held. */
export const FILING_YEARS = '2019 through 2025'

/** When the figures above were last measured against production. */
export const MEASURED_ON = '2026-10-16'

/** "171,801" */
export function fmt(n) {
  return n.toLocaleString('en-US')
}

/** "12.4 million" for prose, where an eight-digit number reads as noise. */
export const GRANTS_PAID_PROSE = '12.4 million'

/** "12.4M" for a stat tile, where the space is not there. */
export const GRANTS_PAID_SHORT = '12.4M'
